import { useQuery } from "@tanstack/react-query";
import AuthFetch from "../../../auth/AuthFetch";
import ms from "ms";

export function useGetEmployeePhoto(entraId: string) {
  const fetchPhoto = async () => {
    try {
      const result = await AuthFetch(
        fetch,
        `${import.meta.env.API_ENDPOINT}/api/FileController/download/employee-photos/${entraId}`,
        { method: "GET" },
      );
      if (!result?.ok) return "";
      const blob = await result.blob();
      return URL.createObjectURL(blob);
    } catch (_e) {
      return "";
    }
  };
  return useQuery({
    queryKey: ["employee-photo", entraId],
    queryFn: fetchPhoto,
    enabled: !!entraId,
    staleTime: ms("10h"),
    refetchOnWindowFocus: false,
  });
}
